<button mat-icon-button [matMenuTriggerFor]="languages">
    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: languageService.selectedLanguage}"></ng-container>
</button>

<mat-menu [xPosition]="'before'" #languages="matMenu" class="frosty-menu-panel">
    <!-- Primary Languages -->
    <ng-container *ngFor="let lang of primaryLanguages">
        <button mat-menu-item (click)="languageService.selectedLanguage=lang">
            <span class="flex items-center">
                <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: lang}"></ng-container>
                <span class="ml-3 font-medium">{{lang.title}}</span>
            </span>
        </button>
    </ng-container>

    <!-- Divider if there are other languages -->
    <mat-divider *ngIf="otherLanguages.length > 0"></mat-divider>

    <!-- Other Languages Submenu -->
    <button mat-menu-item [matMenuTriggerFor]="otherLanguagesMenu" *ngIf="otherLanguages.length > 0">
        <span class="flex items-center">
            <span class="ml-3 font-medium">{{ 'SystemAdmin.Common.OtherLanguages' | translate }}</span>
        </span>
    </button>
</mat-menu>

<mat-menu #otherLanguagesMenu="matMenu" class="frosty-menu-panel">
    <ng-container *ngFor="let lang of otherLanguages">
        <button mat-menu-item (click)="languageService.selectedLanguage=lang">
            <span class="flex items-center">
                <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: lang}"></ng-container>
                <span class="ml-3">{{lang.title}}</span>
            </span>
        </button>
    </ng-container>
</mat-menu>

<ng-template let-lang #flagImage>
    <span class="relative w-6 shadow rounded-sm overflow-hidden">
        <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
        <img class="w-full" [src]="lang.flag" [alt]="'Flag image for ' + lang.title">
    </span>
</ng-template>